<template>
  <div class="setting-index">
    <el-main v-loading="!loaded">
      <el-row :gutter="26">
        <el-col class="setting-main" :span="8" style="margin-left: 7.5%">
          <div style="min-height: 325px">
            <h4>
              企业基本信息
              <span
                v-if="adminType"
                class="title-modify"
                @click="handleModifyAccont"
                >{{ !modifyAccont ? "修改" : "保存" }}</span
              >
            </h4>
            <div class="setting-userInfo" v-if="!modifyAccont">
              <p>
                <span> 企业名称：</span>
                <span>{{ userInfo.name }}</span>
              </p>

              <!-- <p>
                <span>手机号：</span>
                <span>{{ userInfo.mobile }}</span>
              </p> -->

              <!-- <p>
                <span> 用户账号：</span>
                <span>{{ userInfo.username }}</span>
              </p> -->

              <p>
                <span> 联系人姓名：</span>
                <span>{{ userInfo.contact }}</span>
              </p>
              <p style="height: 72px; margin-top: 20px">
                <span>公司logo：</span>
                <span style="margin-top: 10px">
                  <img
                    v-if="userInfo.logoUrl"
                    style="width: 60px; height: 60px"
                    :src="`${$http.defaults.baseURL}/authority-center/open/showImg?path=${userInfo.logoUrl}`"
                    alt
                  />
                  <img
                    v-if="!userInfo.logoUrl"
                    style="width: 60px; height: 60px"
                    src="../assets/company-logo.png"
                    alt
                  />
                </span>
              </p>
              <p style="height: 72px; margin-top: 20px">
                <span>营业执照：</span>
                <span style="margin-top: 10px">
                  <img
                    v-if="userInfo.licenseUrl"
                    style="width: 60px; height: 60px"
                    :src="`${$http.defaults.baseURL}/authority-center/open/showImg?path=${userInfo.licenseUrl}`"
                    alt
                  />
                  <img
                    v-if="!userInfo.licenseUrl"
                    style="width: 60px; height: 60px"
                    src="../assets/company-logo.png"
                    alt
                  />
                </span>
              </p>
            </div>
            <div class="setting-userInfo" v-else>
              <p>
                <span> 企业名称：</span>
                <span>
                  <el-input v-model="userInfo.name"></el-input>
                </span>
              </p>
              <p class="info">
                <i class="el-icon-info"></i
                ><span>单位名称将显示在工资条中,可改为简称。</span>
              </p>
              <!-- <p>
                <span>手机号：</span>
                <span>
                  <el-input v-model="userInfo.mobile"></el-input>
                </span>
              </p>
              <p class="info">
                <i class="el-icon-info"></i><span>如需要修改请联系客服。</span>
              </p>
              <p>
                <span>用户账号：</span>
                <span>
                  <el-input disabled v-model="userInfo.username"></el-input>
                </span>
              </p> -->
              <!--              <p class="info"><i class="el-icon-info"></i><span>默认为注册手机号。</span></p>-->
              <p>
                <span>联系人姓名：</span>
                <span>
                  <el-input v-model="userInfo.contact"></el-input>
                </span>
              </p>
              <p style="height: 72px">
                <span>公司logo：</span>
                <span style="margin-top: 10px">
                  <el-upload
                    ref="upload"
                    :action="`${$http.defaults.baseURL}/authority-center/org/insertLogoOrLicence`"
                    :headers="{
                      Authorization: uploadToken,
                    }"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :before-upload="handleBefore"
                    :on-success="handleSuccess"
                    :on-error="handleError"
                    :before-remove="handleBeforeRemove"
                    :data="{ id: posId, type: 2 }"
                    :on-remove="handleRemove"
                    :file-list="imgList1"
                    accept="image/gif,image/jpeg,image/jpg,image/png"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </span>
              </p>
              <p style="height: 72px">
                <span>营业执照：</span>
                <span style="margin-top: 10px">
                  <el-upload
                    ref="upload1"
                    :headers="{
                      Authorization: uploadToken,
                    }"
                    :action="`${$http.defaults.baseURL}/authority-center/org/insertLogoOrLicence`"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :before-upload="handleBefore1"
                    :on-success="handleSuccess1"
                    :on-error="handleError"
                    :before-remove="handleBeforeRemove1"
                    :data="{ id: posId, type: 1 }"
                    :on-remove="handleRemove1"
                    :file-list="imgList2"
                    accept="image/gif,image/jpeg,image/jpg,image/png"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </span>
              </p>
            </div>
          </div>
          <!-- <div class="usermanage">
            <div>账号设置</div>
            <div>
              <p class="userphone">15587979553</p>
              <p>修改</p>
            </div>
            <div>
              <p class="userphone">15587979553</p>
              <p>修改</p>
            </div>
          </div> -->
          <div style="margin-top: 26px; height: 219px">
            <h4>
              账号设置
              <!-- <span class="title-modify" @click="modifyPassShow = true"
                >修改密码</span
              > -->
            </h4>
            <p class="usersetting" style="margin-top: 20px">
              <span> 用户账号：</span>
              <span>{{ userInfo.username }}</span>
            </p>
            <div class="usersetting">
              <div>手机号：</div>
              <div class="changephone">
                <span>{{ userInfo.mobile }}</span>
                <img
                  @click="changephonenumber"
                  style="height: 15px; margin-left: 8px"
                  src="@/assets/set.png"
                  alt=""
                />
              </div>
            </div>

            <p class="usersetting">
              <span>登录密码：</span>
              <span class="title-modify" @click="changepassword">修改密码</span>
            </p>
          </div>
          <div style="margin-top: 26px">
            <h4>
              邮件发送模板
              <span class="title-modify" @click="handleModifyTemplate"
                >修改</span
              >
            </h4>
          </div>
        </el-col>
        <el-col class="setting-main" :span="13">
          <div>
            <h4>工资条设置</h4>
            <p>
              允许员工访问
              <span class="title-modify">
                <el-switch
                  v-model="userInfo.visible"
                  @change="handleEmployeVisible"
                  active-color="#3BC492"
                  inactive-color="#ff4949"
                ></el-switch>
              </span>
            </p>
          </div>
          <div class="set_user_box">
            <div class="set_user_title">
              <h4>提醒设置</h4>
              <div>
                <!-- <el-link type="primary" style="margin-right:10px">修改</el-link> -->
                <el-link
                  type="primary"
                  style="fontweight: 600"
                  @click="sevrUpdate"
                  >保存修改</el-link
                >
              </div>
            </div>
            <div class="set_user_contnt">
              <div class="title">未签收</div>
              <el-radio-group v-model="signForm.readAlert" size="mini">
                <el-radio :label="false">不提醒</el-radio>
                <el-radio :label="true">提醒</el-radio>
              </el-radio-group>
              <div>
                <span style="margin-right: 5px">发送后</span>
                <el-input-number
                  :disabled="!signForm.readAlert ? true : false"
                  style="width: 80px"
                  v-model="signForm.readAlertDays"
                  size="mini"
                  controls-position="right"
                  :min="1"
                  :max="99"
                >
                </el-input-number>
                <span style="margin-left: 5px">天</span>
              </div>
              <div>
                <el-checkbox
                  :disabled="!signForm.readAlert ? true : false"
                  size="mini"
                  v-model="signForm.readWxAlert"
                  >微信</el-checkbox
                >
                <el-checkbox
                  :disabled="!signForm.readAlert ? true : false"
                  size="mini"
                  v-model="signForm.readSmsAlert"
                  >短信</el-checkbox
                >
                <el-checkbox
                  :disabled="!signForm.readAlert ? true : false"
                  size="mini"
                  v-model="signForm.readEmailAlert"
                ></el-checkbox>
              </div>
            </div>
            <div class="set_user_contnt">
              <div class="title">未读</div>
              <el-radio-group v-model="signForm.signAlert" size="mini">
                <el-radio :label="false">不提醒</el-radio>
                <el-radio :label="true">提醒</el-radio>
              </el-radio-group>
              <div>
                <span style="margin-right: 5px">发送后</span>
                <el-input-number
                  :disabled="!signForm.signAlert ? true : false"
                  style="width: 80px"
                  v-model="signForm.signAlertDays"
                  size="mini"
                  controls-position="right"
                  :min="1"
                  :max="99"
                >
                </el-input-number>
                <span style="margin-left: 5px">天</span>
              </div>
              <div>
                <el-checkbox
                  size="mini"
                  :disabled="!signForm.signAlert ? true : false"
                  v-model="signForm.signWxAlert"
                  >微信</el-checkbox
                >
                <el-checkbox
                  size="mini"
                  :disabled="!signForm.signAlert ? true : false"
                  v-model="signForm.signSmsAlert"
                  >短信</el-checkbox
                >
                <el-checkbox
                  size="mini"
                  :disabled="!signForm.signAlert ? true : false"
                  v-model="signForm.signEmailAlert"
                  >邮箱</el-checkbox
                >
              </div>
            </div>
            <div class="tiText">(使用短信提醒会扣除剩余发送条数)</div>
          </div>
          <div class="set_table_box" v-if="adminType">
            <div class="table_title">
              <h4>管理员设置</h4>
              <span class="el-icon-circle-plus icon" @click="openTable"></span>
            </div>
            <el-table :data="urserTableData" height="250" style="width: 100%">
              <el-table-column prop="fullName" label="姓名" width="180">
              </el-table-column>
              <el-table-column prop="mobile" label="手机号" width="180">
              </el-table-column>
              <el-table-column prop="username" label="账号"> </el-table-column>
              <el-table-column fixed="right" label="操作" width="145">
                <template slot-scope="scope">
                  <el-button
                    @click="openMask(scope.row)"
                    type="text"
                    size="small"
                    >权限管理</el-button
                  >
                  <el-button
                    @click="openPwd(scope.row)"
                    type="text"
                    size="small"
                    >重置密码</el-button
                  >
                  <el-button
                    @click="openUpdate(scope.row)"
                    style="margin-left: 26px"
                    type="text"
                    size="small"
                    >修改</el-button
                  >
                  <el-button
                    @click="delTable(scope.row)"
                    type="text"
                    size="small"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </el-main>
    <el-dialog
      title="修改手机号"
      :visible.sync="phoneshow"
      width="25%"
      height="25%"
      :close-on-click-modal="false"
    >
      <div>
        <el-input
          v-model="changephonedata.mobile"
          placeholder="请输入手机号"
        ></el-input>
      </div>
      <div class="code-container" style="margin: 20px 0">
        <el-input
          v-model="changephonedata.code"
          placeholder="验证码"
        ></el-input>
        <el-button
          style="float: right; width: 95%"
          :disabled="comeFromMail"
          :loading="getCodeLoad"
          @click="getModifyCode(changephonedata.mobile)"
          >{{ getCodeLoad ? btnTime + "s后获取" : "获取验证码" }}</el-button
        >
      </div>

      <div class="phoneokbox">
        <el-button @click="phonedialog">取 消</el-button>
        <el-button type="primary" @click="changeok">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="修改密码"
      :visible.sync="modifyPassShow"
      :before-close="toggleDialog"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form ref="modifyForm" :model="form" label-width="0px">
        <el-form-item
          prop="oldpass"
          :rules="[
            { required: true, message: '密码不能为空' },
            { max: 16, message: '密码不超过16个字符' },
            { min: 6, message: '密码最少6个字符' },
          ]"
        >
          <el-input
            placeholder="请输入旧密码"
            type="password"
            v-model.trim="form.oldpass"
          ></el-input>
        </el-form-item>
        <el-form-item
          :rules="[
            { required: true, message: '密码不能为空' },
            { max: 16, message: '密码不超过16个字符' },
            { min: 6, message: '密码最少6个字符' },
          ]"
          prop="newpass"
        >
          <el-input
            placeholder="请输入新密码"
            type="password"
            v-model.trim="form.newpass"
          ></el-input>
        </el-form-item>
        <el-form-item
          :rules="[
            { required: true, message: '密码不能为空' },
            { max: 16, message: '密码不超过16个字符' },
            { min: 6, message: '密码最少6个字符' },
          ]"
          prop="repass"
        >
          <el-input
            placeholder="确认新密码"
            type="password"
            v-model.trim="form.repass"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="phoneokbox">
        <el-button @click="toggleDialog">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="ImgdialogVisible">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
    <!-- 新增管理员账号 -->
    <el-dialog
      :visible.sync="createDialog"
      @close="delCreate"
      :title="createTitle"
      width="40%"
      :close-on-click-modal="false"
    >
      <el-form
        ref="createUserFef"
        :model="createUser"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="姓名" prop="fullName">
          <el-input
            placeholder="请输入姓名"
            v-model="createUser.fullName"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input
            placeholder="请输入手机号"
            v-model="createUser.mobile"
            :maxlength="11"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="登录账号" prop="username">
          <el-input
            placeholder="请输入登录账号"
            :disabled="createType == 'update' ? true : false"
            v-model="createUser.username"
          ></el-input>
        </el-form-item> -->
        <el-form-item
          label="登录密码"
          prop="password"
          v-if="createType == 'add'"
        >
          <el-input
            placeholder="请输入登录密码"
            type="text"
            v-model.trim="createUser.password"
            class="password"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <div style="text-align: center">
          <el-button @click="createDialog = false">取消</el-button>
          <el-button type="primary" @click="submitCreate()">确认</el-button>
        </div>
      </el-form>
    </el-dialog>
    <!-- 权限管理 -->
    <el-dialog
      :visible.sync="maekDialog"
      @close="createUser = {}"
      title="权限设置"
      width="30%"
      :close-on-click-modal="false"
    >
      <div style="text-align: center; margin: 20px 0">
        <el-radio-group v-model="createUser.permissionMask">
          <el-radio :label="true">所有数据权限</el-radio>
          <el-radio :label="false">独立数据权限</el-radio>
        </el-radio-group>
      </div>
      <div style="text-align: center">
        <el-button @click="maekDialog = false">取消</el-button>
        <el-button type="primary" @click="submitMask()">确认</el-button>
      </div>
    </el-dialog>

    <!-- 模板 -->
    <el-dialog
      title="修改邮件模板"
      :visible.sync="templateShow"
      style="margin-top: -60px"
      :close-on-click-modal="false"
    >
      <div>
        <p style="font-size: 14px; font-weight: 600; padding-bottom: 10px">
          注：『 』内容请勿修改，否则邮件模板无法正常显示
        </p>
      </div>
      <div>
        <edit v-model="richText" :height="'350'"></edit>
        <div style="height: 60px" class="phoneokbox">
          <el-button @click="templateShow = false">取消</el-button>
          <el-button @click="handleTeplateSave" type="primary">保存</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="修改密码"
      :visible.sync="modifyPassShow"
      :before-close="toggleDialog"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-form ref="modifyForm" :model="form" label-width="0px">
        <el-form-item
          prop="oldpass"
          :rules="[
            { required: true, message: '密码不能为空' },
            { max: 16, message: '密码不超过16个字符' },
            { min: 6, message: '密码最少6个字符' },
          ]"
        >
          <el-input
            placeholder="请输入旧密码"
            type="password"
            v-model.trim="form.oldpass"
          ></el-input>
        </el-form-item>
        <el-form-item
          :rules="[
            { required: true, message: '密码不能为空' },
            { max: 16, message: '密码不超过16个字符' },
            { min: 6, message: '密码最少6个字符' },
          ]"
          prop="newpass"
        >
          <el-input
            placeholder="请输入新密码"
            type="password"
            v-model.trim="form.newpass"
          ></el-input>
        </el-form-item>
        <el-form-item
          :rules="[
            { required: true, message: '密码不能为空' },
            { max: 16, message: '密码不超过16个字符' },
            { min: 6, message: '密码最少6个字符' },
          ]"
          prop="repass"
        >
          <el-input
            placeholder="确认新密码"
            type="password"
            v-model.trim="form.repass"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="phoneokbox">
        <el-button @click="toggleDialog">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="ImgdialogVisible" :close-on-click-modal="false">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>

    <!-- 重置密码 -->
    <el-dialog
      :visible.sync="pwdDialog"
      @close="closePwd"
      title="重置密码"
      width="30%"
      :close-on-click-modal="false"
    >
      <el-form :model="createUser" ref="formPwd" label-width="100px">
        <el-form-item
          label="重置密码"
          :rules="[
            {
              required: true,
              message: '请输入密码',
              trigger: 'change',
            },
            {
              pattern: /^[\w_!@#-.]{6,16}$/,
              message: '密码为6-16位（字母，数字，!@#_-. ）',
              trigger: 'change',
            },
          ]"
          prop="newPassword"
        >
          <el-input
            placeholder="请输入新密码"
            type="password"
            v-model.trim="createUser.newPassword"
          ></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: center">
        <el-button @click="pwdDialog = false">取消</el-button>
        <el-button type="primary" @click="submitPwd()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Cookie from "js-cookie";
import { setTimeout } from "timers";
import edit from "@/components/edit";
import { constants } from "crypto";
import { setServiceInfo, setSaveSettings, changephone } from "@/api/setUp.js";
import { log } from "console";
let checkPhone = (rule, value, callback) => {
  let reg = /^1[3456789]\d{9}$/;
  if (!reg.test(value)) {
    callback(new Error("请输入11位手机号"));
  } else {
    callback();
  }
};
export default {
  name: "index",
  components: {
    edit,
  },
  data() {
    return {
      btnTime: 60,
      getCodeLoad: false,
      phoneshow: false,
      comeFromMail: false,
      changephonedata: {
        mobile: "",
        code: "",
        id: "",
      },
      imgList1: [],
      imgList2: [],
      posId: "",
      createUser: {},
      pwdUser: {},
      createDialog: false,
      pwdDialog: false,
      createType: "add",
      createTitle: "",
      urserTableData: [],
      maekDialog: false,
      signForm: {
        readAlert: false,
        readAlertDays: 1,
        readWxAlert: false,
        readSmsAlert: false,
        readEmailAlert: false,
        signAlert: false,
        signAlertDays: 1,
        signWxAlert: false,
        signSmsAlert: false,
        signEmailAlert: false,
      },
      rules: {
        fullName: [
          { required: true, message: "请输入姓名", trigger: "change" },
          {
            min: 1,
            max: 10,
            message: "姓名在 1 到 10 个字符",
            trigger: "change",
          },
        ],
        mobile: [
          { required: true, message: "请输入手机", trigger: "change" },
          {
            type: "number",
            validator: checkPhone,
            message: "请输入正确的手机号",
            trigger: "change",
          },
        ],
        username: [
          { required: true, message: "请输入用户名", trigger: "change" },
          {
            pattern: /^[a-zA-Z0-9\._-]{6,16}$/,
            message: "用户名为6到16位（字母，数字，下划线，减号，点号）",
            trigger: "change",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "change",
          },
          {
            pattern: /^[\w_!@#-.]{6,16}$/,
            message: "密码为6-16位（字母，数字，!@#_-. ）",
            trigger: "change",
          },
        ],
      },
      defautlImg: [],
      dialogImageUrl: "",
      ImgdialogVisible: false,
      lincenseImg: "",
      fileList1: 0,
      modifyAccont: false,
      userInfo: "",
      modifyPassShow: false,
      uploadToken: "Bearer " + window.sessionStorage.getItem("token"),
      form: {
        oldpass: "",
        repass: "",
        newpass: "",
      },
      infoDetail: {
        name: "",
        contact: "",
        mobile: "",
        logoUrl: "",
      },
      templateShow: false,
      richText: "",
      loadingBtn: false,
      loaded: false,
      adminType: false,
    };
  },
  methods: {
    changepassword() {
      this.modifyPassShow = true;
    },
    phonedialog() {
      this.phoneshow = false;
    },
    async changeok() {
      let { data } = await changephone(this.changephonedata);
      if (data.code == 200) {
        this.$notify({
          title: "成功",
          message: "修改成功",
          type: "success",
        });
        this.phoneshow = false;
      } else {
        this.$notify({
          title: "警告",
          message: "修改失败",
          type: "warning",
        });
      }
    },
    getModifyCode(test) {
      let phoneReg = new RegExp(/^1\d{10}$/);
      if (phoneReg.test(test)) {
        this.btnTime = 60;
        this.getCodeLoad = true;
        var timer = setInterval(() => {
          this.btnTime--;
          if (this.btnTime <= 0) {
            this.getCodeLoad = false;
            clearInterval(timer);
          }
        }, 1000);
        this.$http.post(`/authority-center/open/sms_code?mobile=${test}`).then(
          (res) => {
            if (res.data.code == 200) {
              this.$notify({
                title: "成功",
                message: "验证码已发送至手机，请注意查收",
                type: "success",
              });
            } else {
              this.$notify({
                title: "警告",
                message: res.data.msg || "网络异常",
                type: "warning",
              });
            }
          },
          (error) => {
            this.btnTime = 0;
          }
        );
      } else {
        this.$message({
          message: "请填写正确的手机号码",
          type: "warning",
        });
      }
    },
    openPwd(data) {
      this.pwdDialog = true;
      this.createUser = { ...data };
    },
    openMask(data) {
      this.maekDialog = true;
      this.createUser = { ...data };
      console.log(this.createUser);
    },
    openUpdate(data) {
      this.createDialog = true;
      this.createTitle = "修改";
      this.createType = "update";
      this.createUser = { ...data };
    },
    closePwd() {
      this.createUser = {};
      this.$refs["formPwd"].resetFields();
    },
    submitPwd() {
      this.$refs["formPwd"].validate((valid) => {
        console.log(valid);
        if (valid) {
          this.$http
            .post(
              `authority-center/tenant/user/changepwd?newPassword=${this.createUser.newPassword}&username=${this.createUser.username}`
            )
            .then((res) => {
              if (res.data.code == 200) {
                this.$notify({
                  title: "成功",
                  message: "操作成功",
                  type: "success",
                });
                this.pwdDialog = false;
                this.getUserTableList();
              } else {
                this.$notify({
                  title: "失败",
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
        }
      });
    },
    delTable(data) {
      this.$confirm("是否删除管理员?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      }).then(() => {
        this.$http
          .delete(`authority-center/tenant/user/${data.id}/delete`)
          .then((res) => {
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success",
            });
            this.getUserTableList();
          });
      });
    },
    openTable() {
      this.createType = "add";
      this.createDialog = true;
      this.createTitle = "新增";
    },
    delCreate() {
      this.createUser = {};
      this.$refs["createUserFef"].resetFields();
    },
    submitMask() {
      this.$http
        .put("authority-center/tenant/user/update", this.createUser)
        .then((res) => {
          if (res.data.code == 200) {
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success",
            });
            this.maekDialog = false;
            this.getUserTableList();
          } else {
            this.$notify({
              title: "失败",
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    submitCreate() {
      this.$refs["createUserFef"].validate((valid) => {
        if (valid) {
          if (this.createType == "add") {
            this.createUser.permissionMask = false;
            this.$http
              .post("authority-center/tenant/user/create", {
                fullName: this.createUser.fullName,
                mobile: this.createUser.mobile,
                username: this.createUser.mobile,
                password: this.createUser.password,
              })
              .then((res) => {
                if (res.data.code == 200) {
                  this.$notify({
                    title: "成功",
                    message: "操作成功",
                    type: "success",
                  });
                  this.createDialog = false;
                  this.getUserTableList();
                } else {
                  this.$notify({
                    title: "失败",
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
          } else {
            this.$http
              .put("authority-center/tenant/user/update", this.createUser)
              .then((res) => {
                if (res.data.code == 200) {
                  this.$notify({
                    title: "成功",
                    message: "操作成功",
                    type: "success",
                  });
                  this.createDialog = false;
                  this.getUserTableList();
                } else {
                  this.$notify({
                    title: "失败",
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
          }
        }
      });
    },
    async handleEmployeVisible(val) {
      if (val) {
        this.$http
          .post("authority-center/open/updateCustomerInfo", {
            ...this.userInfo,
            ...{ fullName: this.userInfo.contact, id: this.posId },
          })
          .then((res) => {
            if (res.data.code == 200) {
              this.$notify({
                title: "成功",
                message: "操作成功",
                type: "success",
              });
              this.getUserInfo();
            }
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        this.$confirm("此操作会让员工不能访问工资条链接, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          confirmButtonClass: "el-button--default",
          cancelButtonClass: "el-button el-button--danger",
          type: "warning",
          closeOnClickModal: false,
        })
          .then(() => {
            this.$http
              .post("authority-center/open/updateCustomerInfo", {
                ...this.userInfo,
                ...{ fullName: this.userInfo.contact, id: this.posId },
              })
              .then((res) => {
                if (res.data.code == 200) {
                  this.$notify({
                    title: "成功",
                    message: "操作成功",
                    type: "success",
                  });
                  this.getUserInfo();
                }
              })
              .catch((e) => {
                console.log(e);
              });
          })
          .catch(() => {
            this.userInfo.visible = true;
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      }
    },
    async handleTeplateSave() {
      if (this.richText) {
        this.loadingBtn = true;
        try {
          let res = await this.$http.post(
            "/salary-service/customer/email/update",
            {
              content: this.richText,
            }
          );
          this.$notify({
            title: "成功",
            message: "邮件模板修改成功",
            type: "success",
          });
          this.loadingBtn = false;
          this.richText = "";
          this.templateShow = false;
        } catch (e) {}
      }
    },
    async sevrUpdate() {
      const res = await setSaveSettings(this.signForm);
      if (res.data.code == 200) {
        this.$notify({
          title: "成功",
          message: "保存成功",
          type: "success",
        });
      }
    },
    async handleModifyTemplate() {
      this.templateShow = true;
      try {
        let res = await this.$http.get(`/salary-service/customer/getEmail`);
        this.richText = res.data.data.content;
      } catch (e) {}
    },
    toggleDialog() {
      //切换前清空数据检测
      this.from = "";
      this.$refs["modifyForm"].resetFields();
      this.modifyPassShow = false;
    },
    handleSubmit() {
      // this.form = {
      //   oldpass: '',
      //   repass: '',
      //   newpass: '',
      // }
      this.$refs["modifyForm"].validate((valid) => {
        if (valid) {
          let pwdReg = /^[\w_!@#-.]{6,16}$/;
          if (pwdReg.test(this.form.newpass)) {
            if (this.form.newpass == this.form.repass) {
              this.$http
                .post(
                  `authority-center/common/changepwd?newPassword=${this.form.newpass}&oldPassword=${this.form.oldpass}`
                )
                .then((res) => {
                  if (res.data.code == 200) {
                    this.$notify({
                      title: "成功",
                      message: "密码修改成功",
                      type: "success",
                    });
                    this.$router.push("/");
                    window.sessionStorage.setItem("token", "");
                  } else {
                    this.$notify({
                      title: "失败",
                      message: res.data.msg || "网络异常",
                      type: "warning",
                    });
                  }
                  // this.modifyPassShow = false
                  this.toggleDialog();
                });
            } else {
              this.$message({
                message: "两次输入的密码不匹配，请重试",
                type: "warning",
              });
            }
          } else {
            this.$message({
              message: "密码为6-16位（字母，数字，!@#_-. ）",
              type: "warning",
            });
          }
        } else {
          return false;
        }
      });
    },
    handleModifyAccont() {
      if (!this.modifyAccont) {
        this.modifyAccont = true;
        this.$nextTick(() => {
          this.userInfo.logoUrl
            ? (this.imgList1 = [
                {
                  name: "img1",
                  url: `${this.$http.defaults.baseURL}/authority-center/open/showImg?path=${this.userInfo.logoUrl}`,
                },
              ])
            : (this.imgList1 = []);
          this.imgList1.length
            ? (this.$refs.upload.$children[1].$el.style.display = "none")
            : null;
          this.userInfo.licenseUrl
            ? (this.imgList2 = [
                {
                  name: "img1",
                  url: `${this.$http.defaults.baseURL}/authority-center/open/showImg?path=${this.userInfo.licenseUrl}`,
                },
              ])
            : (this.imgList2 = []);
          this.imgList2.length
            ? (this.$refs.upload1.$children[1].$el.style.display = "none")
            : null;
        });
      } else {
        this.$confirm("此操作将更新账号信息, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          confirmButtonClass: "el-button--default",
          cancelButtonClass: "el-button ",
          type: "warning",
          closeOnClickModal: false,
        })
          .then(() => {
            let regeAbbreviation = new RegExp(
              /^[\u4E00-\u9FA5\(\)（）\.\_\a-zA-Z&]{2,30}$/gi
            );
            let regeMobile = new RegExp(/^1\d{10}$/);
            let rege1 = new RegExp(/^[\u4E00-\u9FA5\a-zA-Z&\s]{0,10}$/g);
            if (
              regeAbbreviation.test(this.userInfo.name) &&
              regeMobile.test(this.userInfo.mobile) &&
              rege1.test(this.userInfo.contact)
            ) {
              this.$http
                .post("authority-center/open/updateCustomerInfo", {
                  ...this.userInfo,
                  ...{ fullName: this.userInfo.contact, id: this.posId },
                })
                .then((res) => {
                  this.modifyAccont = false;
                  if (res.data.code == 200) {
                    this.getUserInfo();
                    this.$message({
                      type: "success",
                      message: "操作成功!",
                    });
                  } else {
                    this.$message({
                      type: "warning",
                      message: res.data.msg || "操作失败!",
                    });
                    this.getUserInfo();
                  }
                });
            } else {
              this.$message({
                type: "warning",
                message:
                  "企业名称由2-30位汉字、字母、合法符号组成联系人由10个字符组成，包含汉字、字母、空格",
              });
              this.getUserInfo();
            }
          })
          .catch(() => {
            this.modifyAccont = false;
            this.$message({
              type: "info",
              message: "已取消",
            });
            this.getUserInfo();
          });
      }
    },
    // handleRemove1(file, fileList) {
    //   this.$refs.upload1.$children[0].$el.style.display = "none";
    //   this.$refs.upload1.$children[1].$el.style.display = "flex";
    //    this.lincenseImg=''
    // },
    // handleSuccess1(response, file, fileList) {
    //   this.fileList1 = fileList.length;
    //   this.lincenseImg = response.data[0];
    // },
    // handleBefore1() {
    //   this.$refs.upload1.$children[1].$el.style.display = "none";
    //   this.$refs.upload1.$children[0].$el.style.display = "inline-block";
    // },
    // handlePictureCardPreview(file) {
    //   this.dialogImageUrl = file.url;
    //   this.ImgdialogVisible = true;
    // },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.ImgdialogVisible = true;
    },
    handleRemove(file, fileList) {
      this.$refs.upload.$children[0].$el.style.display = "none";
      this.$refs.upload.$children[1].$el.style.display = "flex";
      this.logoImg = "";
      this.userInfo.logo = "";
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleError() {
      this.$notify({
        title: "失败",
        message: "图片上传失败，请稍后重试",
        type: "error",
      });
    },
    handleSuccess(response, file, fileList) {
      debugger;
      if (response.data.code == 200) {
        // this.fileList1 = fileList.length
        this.userInfo.logoUrl = response.data.data;
      } else {
        this.$notify({
          title: "失败",
          message: `${response.message},请删除后重新上传`,
          type: "warning",
        });
      }
      // this.logoImg = response.data[0];
    },
    handleBefore() {
      this.$refs.upload.$children[1].$el.style.display = "none";
      this.$refs.upload.$children[0].$el.style.display = "inline-block";
    },
    //
    handleRemove1(file, fileList) {
      this.$refs.upload1.$children[0].$el.style.display = "none";
      this.$refs.upload1.$children[1].$el.style.display = "flex";
      this.lincenseImg = "";
      this.userInfo.businessLicence = "";
    },
    handleSuccess1(response, file, fileList) {
      if (response.data.code == 200) {
        // this.fileList1 = fileList.length
        this.userInfo.licenseUrl = response.data.data;
      } else {
        this.$notify({
          title: "失败",
          message: `${response.message},请删除后重新上传`,
          type: "warning",
        });
      }
    },
    handleBefore1() {
      this.$refs.upload1.$children[1].$el.style.display = "none";
      this.$refs.upload1.$children[0].$el.style.display = "inline-block";
    },
    handleBeforeRemove() {
      this.userInfo.logoUrl = "";
    },

    handleBeforeRemove1() {
      this.userInfo.licenseUrl = "";
    },
    getUserInfo() {
      this.$http.get("authority-center/common/user/info").then((res) => {
        this.posId = res.data.orgId;
        this.adminType = res.data.admin;
        const username = res.data.username;
        console.log(res, "res-----------------");
        this.changephonedata.id = res.data.id;
        this.$http.get(`authority-center/org/${res.data.orgId}`).then((res) => {
          this.userInfo = res.data;
          this.userInfo.username = username;
          this.loaded = true;
          if (this.userInfo.visible === null) {
            this.userInfo.visible = true;
          }
        });
      });
    },
    getUserTableList() {
      this.$http
        .get(`authority-center/tenant/user/page?pageNumber=0&size=10`)
        .then((res) => {
          this.urserTableData = res.data;
        });
    },
    getSetSetting() {
      this.$http.get(`salary-service/common/settings`).then((res) => {
        this.signForm = res.data;
      });
    },
    changephonenumber() {
      this.phoneshow = true;
    },
  },
  mounted() {
    this.getSetSetting();
    this.getUserInfo();
    this.getUserTableList();
    // this.userInfo = Cookie.get("userInfo")
    //   ? JSON.parse(Cookie.get("userInfo"))
    //   : "";
    //   this.switchVal=this.userInfo.isVisible
    // console.log(this.userInfo)
    // this.userInfo.logoUrl?this.defautlImg.push({name:'img1',url:this.userInfo.logoUrl}):this.defautlImg=[]
  },
};
</script>

<style lang="less" scoped>
.title-modify {
  color: #3bc492;
  float: right;
  font-size: 14px;
  line-height: 27px;
  cursor: pointer;
}

.setting-index {
  background-color: rgba(243, 245, 247, 1);
  min-height: calc(100vh - 80px);
  padding-top: 32px;
  .setting-main > div {
    background-color: #fff;
    border-radius: 8px;
    padding: 20px;
    h4 {
      font-size: 18px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      color: rgba(44, 45, 58, 1);
    }
    p {
      font-size: 14px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(44, 45, 58, 1);
      line-height: 36px;
      height: 36px;
    }
  }
  .set_user_box {
    margin-top: 20px;
    .tiText {
      margin-top: 10px;
      color: #ccc;
      text-align: right;
    }
    .set_user_title {
      display: flex;
      justify-content: space-between;
    }
    .set_user_contnt {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 26px;
      .title {
        width: 48px;
      }
    }
  }
  .set_table_box {
    margin-top: 20px;
    .table_title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .icon {
        font-size: 25px;
        cursor: pointer;
      }
    }
  }
  .setting-userInfo p {
    display: flex;
    justify-content: space-between;
    height: 25px;
    line-height: 25px;
  }
  .setting-userInfo .info {
    display: block;
    margin-bottom: 10px;
    height: 25px;
    line-height: 25px;
    font-size: 12px;
  }
  .setting-userInfo span {
    // float: right;
    .el-input {
      width: 150px;
      height: 30px;
    }
  }
}
/deep/.el-link--inner {
  font-weight: 600;
}
/deep/.title {
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #2c2d3a;
}
.usersetting {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.changephone {
  display: flex;
  align-items: center;
  justify-content: left;
  margin: 10px 0;
}
.usersetting div {
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: #2c2d3a;
  line-height: 36px;
}

.code-container {
  display: flex;
  /deep/.el-button {
    flex: 1;
    margin-left: 20px;
  }
}
.phoneokbox {
  display: flex;
  align-items: center;
  justify-content: center;
}

.password {
  -webkit-text-security: disc;
  font-family: text-security-disc;
}
</style>
